<template>
  <div id="root">
    <h5>{{ meditation.title }}</h5>
    <p v-html="meditation.content" class="text-muted" />
  </div>
</template>

<script>
export default {
    props: {
        // eslint-disable-next-line vue/require-default-prop
        meditation: Object
    },
    // data() {
    //     return {
    //         rawHtml: ,
    //     };
    // }
};
</script>
